import React, { useState } from "react";
// import { AxiosInstance } from "../../../common/Loader/axios.config";
import Swal from "sweetalert2";
import { IoClose } from "react-icons/io5";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import { AxiosInstance } from "../../../../common/Loader/axios.config";
import Select from 'react-select';

const EditProjectModal = ({ isOpen, onClose, selectedProject, fetchProjects }) => {

  const tagOptions = [
    { value: 'comedy', label: 'Comedy' },
    { value: 'drama', label: 'Drama' },
    { value: 'action', label: 'Action' },
    { value: 'adventure', label: 'Adventure' },
  ];

  const [formDataState, setFormDataState] = useState({
    name: selectedProject.name,
    description: selectedProject.description,
    price: selectedProject.price,
    category: selectedProject.category,
    tags: selectedProject.tags || []
  });

  const [selectedTag, setSelectedTag] = useState(
    selectedProject.tags
      ? selectedProject.tags.map(tag =>
        tagOptions.find(option => option.value === tag)
      ).filter(Boolean)
      : []
  );
  const [videoTags, setVideoTags] = useState('');

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataState({ ...formDataState, [name]: value });
  };

  const handleTagChange = (options) => {
    setSelectedTag(options);
    const values = options.map(option => option.value);
    setVideoTags(values.join(','));
    setFormDataState(prev => ({
      ...prev,
      tags: values
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    // Create a new FormData object
    const formData = new FormData();

    // Get the form data state
    const { name, description, price, category, tags } = formDataState;

    // Append all fields
    formData.append('name', name);
    formData.append('description', description);
    formData.append('price', price);
    formData.append('category', category);

    // Handle tags as array
    // if (Array.isArray(tags)) {
    //   tags.forEach(tag => formData.append('tags[]', tag));
    // }

    if (Array.isArray(tags)) {
      formData.append('tags', JSON.stringify(tags));
    }

    // Log the form data after it's populated
    console.log("Form Data:")
    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    AxiosInstance.put(`/${selectedProject._id}/project`, formData)
      .then((response) => {
        console.log("Project Update Response", response);
        if (response.data.status === "success") {
          const contentId = response.data.message._id;
          Swal.fire({
            icon: "success",
            title: "Content Updated successfully! ",
            text: `${selectedProject.name} has been updated successfully!`,
            showConfirmButton: false,
            timer: 2000,
          });
          onClose();
          fetchProjects();
          setLoading(false);
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed to update provider",
            text: `${response.data.message}`,
            showConfirmButton: false,
            timer: 2000,
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Failed to update provider",
          text: "An error occurred while updating the provider.",
        });
        setLoading(false);
      });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75">
      <div className="relative w-1/2 rounded-lg bg-brand-background p-6">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-2xl text-white"
        >
          <IoClose />
        </button>
        <h2 className="mb-4 text-lg font-semibold text-white">Edit Project</h2>
        <form
          onSubmit={handleSubmit}
          className="flex flex-col gap-4 text-black"
        >
          <div>
            <label className="mb-2 block text-white">Name</label>
            <input
              type="text"
              name="name"
              value={formDataState.name}
              onChange={handleChange}
              className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-white"
            />
          </div>
          <div>
            <label className="mb-2 block text-white">Description</label>
            <textarea
              name="description"
              value={formDataState.description}
              onChange={handleChange}
              className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-white"
            />
          </div>
          <div>
            <label className="mb-2 block text-white">Price</label>
            <input
              type="text"
              name="price"
              value={formDataState.price}
              onChange={handleChange}
              className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-white"
            />
          </div>

          <div>
            <label className="mb-2 block text-white">Tags</label>
            <Select
              isMulti
              value={selectedTag}
              onChange={handleTagChange}
              options={tagOptions}
              placeholder="Select Tags..."
            />
          </div>

          <div>
            <label className="mb-2 block text-white">Category</label>
            <select
              name="category"
              value={formDataState.category}
              onChange={handleChange}
              className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-black"
            >
              <option value="">Select Category...</option>
              <option value="tv">TV</option>
              <option value="vod">Video</option>
              <option value="event">Event</option>
              <option value="shorts">Shorts</option>
              <option value="series">Series</option>
            </select>
          </div>
          <div className="col-span-2">
            <button
              type="submit"
              className="rounded bg-primary px-4 py-2 text-white"
            >
              {loading ? <ClipLoader size={20} color="#FFFFFF" /> : "Update"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProjectModal;
